import { FunctionComponent, useState } from 'react';
import {
    Card,
    CardContent,
    Divider,
    Typography,
    Box,
    Button,
} from '@mui/material';
import { Customer } from '@/models/customer';
import { usePutCustomerMutation } from '@/api/v2/customer';
import { useNotification } from '@starjack/features/notifications';
import { MarkdownInput } from '@starjack/shared-components';

type NotesCardProps = {
    customer: Customer;
};

export const NotesCard: FunctionComponent<NotesCardProps> = ({ customer }) => {
    const [notes, setNotes] = useState(customer.notes || '');
    const [propNotes, setPropNotes] = useState(customer.notes || '');
    const [putCustomer, { isLoading }] = usePutCustomerMutation();
    const { addNotification } = useNotification();

    if (customer.notes !== propNotes) {
        setPropNotes(customer.notes);
        setNotes(customer.notes);
    }

    const onMarkdownChange = (nextVal: string) => {
        setNotes(nextVal);
    };

    const handleSave = async () => {
        try {
            await putCustomer({
                ...customer,
                notes,
            }).unwrap();

            addNotification({
                type: 'success',
                message: 'Notiz wurde gespeichert',
            });
        } catch {
            addNotification({
                type: 'error',
                message:
                    'Fehler beim Speichern. Bitte versuchen Sie es später noch einmal',
            });
        }
    };

    return (
        <Card>
            <CardContent
                sx={{
                    bgcolor: 'divider',
                }}
            >
                <Typography variant='h6'>Notizen</Typography>
            </CardContent>
            <Divider
                sx={{
                    width: '100%',
                }}
            />

            <CardContent
                sx={{
                    padding: 4,
                }}
            >
                <MarkdownInput value={notes} onChange={onMarkdownChange} />

                <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                    <Button
                        loading={isLoading}
                        variant='contained'
                        size='small'
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};
